import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "rec-search-bar__input-wrap" };
const _hoisted_2 = ["placeholder"];
const _hoisted_3 = ["aria-label"];
const _hoisted_4 = ["aria-label"];
import { nextTick, onMounted, ref, watch } from "vue";
// Components
import SvgIcon from "@/common/components/SvgIcon.vue";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchInput',
    props: /*@__PURE__*/ _mergeModels({
        placeholder: { default: "" },
        updateOnInput: { type: Boolean },
        autofocus: { type: Boolean }
    }, {
        "modelValue": { default: "" },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props, { expose: __expose }) {
        const props = __props;
        const model = _useModel(__props, "modelValue");
        const search = ref(model.value);
        const searchInput = ref();
        watch(search, () => {
            if (props.updateOnInput)
                handleSearch();
        });
        const handleSearch = () => {
            model.value = search.value;
        };
        const handleClear = () => {
            search.value = "";
            handleSearch();
        };
        onMounted(() => {
            if (!props.autofocus || !searchInput.value)
                return;
            nextTick(() => searchInput.value?.focus());
        });
        const focus = () => searchInput.value?.focus();
        __expose({ focus });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({ 'rec-search-bar': true, 'rec-search-bar--no-button': _ctx.updateOnInput })
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _withDirectives(_createElementVNode("input", {
                        ref_key: "searchInput",
                        ref: searchInput,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                        class: _normalizeClass(["form-control rc-hasClear", { 'rc-highlight': search.value != '', 'no-button': _ctx.updateOnInput }]),
                        type: "search",
                        placeholder: _ctx.placeholder,
                        onKeyup: [
                            _withKeys(handleSearch, ["enter"]),
                            _withKeys(handleClear, ["esc"])
                        ]
                    }, null, 42, _hoisted_2), [
                        [_vModelText, search.value]
                    ]),
                    (search.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "rec-search-bar__clear",
                            "aria-label": _ctx.$t('Clear Filter'),
                            onClick: handleClear,
                            onKeyup: _withKeys(handleClear, ["enter"])
                        }, [
                            _createVNode(SvgIcon, {
                                class: "rec-search-bar__clear__icon",
                                icon: "icon-close-3"
                            })
                        ], 40, _hoisted_3))
                        : _createCommentVNode("", true)
                ]),
                (!_ctx.updateOnInput)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-icon",
                        "aria-label": _ctx.$t('Search'),
                        onClick: handleSearch,
                        onKeyup: _withKeys(handleSearch, ["enter"])
                    }, [
                        _createVNode(SvgIcon, {
                            class: "rc-icon rc-icon-search",
                            icon: "icon-search"
                        })
                    ], 40, _hoisted_4))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
